import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';
import API_BASE from '../utils/config';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const { hotel } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!hotel) return;
    const s = io(API_BASE || window.location.origin);
    s.on('connect', () => {
      s.emit('join-hotel', hotel.id);
    });
    setSocket(s);
    return () => s.disconnect();
  }, [hotel]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
}

export const useSocket = () => useContext(SocketContext);
